import { render, staticRenderFns } from "./MPieChart.vue?vue&type=template&id=3f6bf27f&"
import script from "./MPieChart.vue?vue&type=script&lang=js&"
export * from "./MPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports